// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"09e350c7","56":"f38a93ae","223":"84b63a05","321":"176fe133","338":"e7d8bceb","453":"d855a71b","518":"ae32c403","547":"3dd119d7","588":"fe024349"}[chunkId] + ".chunk.js";
};